import axios from "axios";
import config from "../config";

const url = config.API_URL;
const financeUrl = "finance";

const apiGet = async (url) => {
  return axios.get(`${config.API_URL}${url}`);
};

const apiDelete = async (url, token) => {
  return axios.delete(`${config.API_URL}${url}`, {
    headers: { "X-API-KEY": token },
  });
};

const apiPost = async (url, form) => {
  return axios.post(`${config.API_URL}${url}`, form);
};

export const getAllRequests = async () => {
  const url = `request/all`;
  return apiGet(url);
};

export const getMyHRStatus = async(requestId) => {
  const url = `request/getmyhrstatus?requestId=${requestId}`;
  return apiGet(url);
};

export const getRequest = async (id) => {
  const url = `request/${id}`;
  return apiGet(url);
};

// export const getEmployeeByEmail = async (email) => {
//   const url = `employee/getemployeebyemail?email=${email}`;
//   return apiGet(url);
// };

export const apiRejectFinance = async (requestId, reason) => {
  const data = {
    Id: parseInt(requestId, 10),
    Reason: reason,
  };
  return apiPost(`approval/rejectfinance/`, data);
};

export const apiApproveFinance = async (requestId) => {
  const data = {
    Id: parseInt(requestId, 10)
  };
  return apiPost(`approval/approvefinance/`, data);
};



export const apiResubmitFinance = async (requestId, reason) => {
  const data = {
    Id: parseInt(requestId, 10),
    Reason: reason,
  };
  return apiPost(`request/resubmit`, data);
};

export const apiDeleteFile = async (token, fileName) => {
  return apiDelete(`file/RemoveFileAttachment/${fileName}`, token);
};

export const apiPostFiles = async (form) => {
  return apiPost(`file/AddFileAttachment`, form);
};
